import { lazy } from 'react'

// Public Pages
export const Terms = lazy(() => import('../../pages/Terms'))
export const Privacy = lazy(() => import('../../pages/Privacy'))
export const About = lazy(() => import('../../pages/About'))
export const Paul = lazy(() => import('../../pages/Paul'))
export const Blog = lazy(() => import('../../pages/Blog'))
export const BlogPost = lazy(() => import('../../pages/blog/BlogPost'))
export const HumanAIProject = lazy(() => import('../../pages/HumanAIProject'))
export const Careers = lazy(() => import('../../pages/Careers'))
export const HowWeProtectYourVoice = lazy(() => import('../../pages/HowWeProtectYourVoice'))
export const KeepThisVoiceForever = lazy(() => import('../../pages/KeepThisVoiceForever'))
export const Waitlist = lazy(() => import('../../pages/love/Waitlist'))
export const AdminWaitlist = lazy(() => import('../../pages/love/AdminWaitlist'))

// Auth Pages
export const Login = lazy(() => import('../../pages/Login'))
export const PhoneVerify = lazy(() => import('../../pages/PhoneVerify'))
export const AccountRecovery = lazy(() => import('../../pages/AccountRecovery'))
export const ForgotAccess = lazy(() => import('../../pages/ForgotAccess'))
export const QrAuth = lazy(() => import('../../pages/QrAuth'))

// Love Letter Service Pages
export const LoveLanding = lazy(() => import('../../pages/love/LoveLanding'))
export const LoveAccount = lazy(() => import('../../pages/love/LoveAccount'))
